export default {
  'menu.welcome': '欢迎',
  'menu.home': '首页',
  'menu.login': '登录',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.account.logout': '退出登录',
  'menu.analysis': '数据看板',
  'menu.workbench': '工作台',
  'menu.workbench.finance-report': '财务概览',
  'menu.workbench.todo': '我的待办',
  'menu.project-center': '项目管理',
  'menu.project-center.project': '项目列表',
  'menu.project-center.board': '项目看板',
  'menu.project-center.quotation': '报价单',
  'menu.finance': '财务管理',
  'menu.finance.receivable': '应收账款',
  'menu.finance.payment': '收款记录',
  'menu.finance.bill': '账单管理',
  'menu.system': '系统管理',
  'menu.system.sys-user': '用户管理',
  'menu.system.sys-role': '角色管理',
  'menu.system.sys-log': '系统日志',
  'menu.system.sys-api': 'API管理',
  'menu.system.sys-dict': '字典管理',
  'menu.project': '项目列表',
  'menu.quotation': '报价单管理',
  'menu.receivable': '应收账款',
  'menu.payment': '收款记录',
  'menu.bill': '账单管理',
  'menu.finance-report': '财务概览',
  'menu.board': '项目看板',
  'menu.todo': '我的待办',
  'menu.customer': '客户管理',
  'menu.sales': '销售管理',
  'menu.visit': '拜访管理',
  'menu.delivery': '货代运单管理',
  'menu.receive': '签收单管理',
  'menu.carrier': '货代公司管理',
  'menu.file': '文件管理',
};
